import { FEATURE_FLAGS } from "@/lib/featureFlags";

export const TUNNELED_MCP_FEATURE_FLAG = FEATURE_FLAGS.tunneledMcp;
